import {} from '@tanstack/query-core';
import {} from 'viem';
import { writeContract, } from '../actions/writeContract.js';
import {} from '../createConfig.js';
import {} from '../types/utils.js';
export function writeContractMutationOptions(config) {
    return {
        mutationFn(variables) {
            return writeContract(config, variables);
        },
        mutationKey: ['writeContract'],
    };
}
//# sourceMappingURL=writeContract.js.map